(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('TimeseriesDataMnemonicOpen', TimeseriesDataMnemonicOpen);

    TimeseriesDataMnemonicOpen.$inject = ['$resource', 'DateUtils'];

    function TimeseriesDataMnemonicOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/timeseries-data-mnemonic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
